import Window from './Window';

function SocialsWindow() {
  return (
    <section className="mt-4">
      <Window
        title="socials.png"
        barBgColor="#7371ff"
        borderColor="#3533cc"
        bgColor="#05039177"
      >
        <div className="d-flex text-center justify-content-between p-3">
          <a
            href="https://x.com/kaypxz"
            target="_blank"
            rel="noreferrer"
            className="social-img px-1"
          >
            <img
              src="/images/socials/twitter.png"
              alt="twitter"
              className="shadow-sm"
            />
          </a>
          <a
            href="https://www.instagram.com/kay.pxz/"
            target="_blank"
            rel="noreferrer"
            className="social-img px-1"
          >
            <img
              src="/images/socials/ig.png"
              alt="instagram"
              className=" shadow-sm"
            />
          </a>
          <a
            href="https://vgen.co/kaypxz"
            target="_blank"
            rel="noreferrer"
            className="social-img px-1"
          >
            <img
              src="/images/socials/vgen.png"
              alt="vgen"
              className="shadow-sm"
            />
          </a>
          <a
            href="https://ko-fi.com/kaypxz"
            target="_blank"
            rel="noreferrer"
            className="social-img px-1"
          >
            <img
              src="/images/socials/kofi.png"
              alt="ko-fi"
              className="shadow-sm"
            />
          </a>
          <a
            href="https://bsky.app/profile/kaypxz.bsky.social"
            target="_blank"
            rel="noreferrer"
            className="social-img px-1"
          >
            <img
              src="/images/socials/bsky.png"
              alt="twitter"
              className="shadow-sm"
            />
          </a>
          <a
            href="https://kaypxz.tumblr.com/"
            target="_blank"
            rel="noreferrer"
            className="social-img px-1"
          >
            <img
              src="/images/socials/tumblr.png"
              alt="instagram"
              className=" shadow-sm"
            />
          </a>
        </div>
      </Window>
    </section>
  );
}

export default SocialsWindow;
